<template>
  <div class="member-learning">
    <!--面板中的内容-->
    <div class="member-right-inner-bottom">


      <!--       如果需要使用收起全部的功能,ref必须要写,ref不要使用同一个，ref设置在Pen组件-->
     <!-- <div style="clear: both;">
        <button class="btn-close-all" @click="closeAll">收起全部</button>
      </div>-->

      <pen-panel text="统计" :closAble="true" ref="countTeachingInfo">
<!--        <div style="padding: 20px">-->
<!--          <el-form label-width="100px">-->
<!--            <el-row :gutter="20">-->
<!--              <el-col :span="8">-->
<!--                <el-form-item label="统计类型：">-->
<!--                  <el-select v-model="form.type" multiple placeholder="请选择">-->
<!--                    <el-option-->
<!--                      v-for="item in options"-->
<!--                      :key="item.value"-->
<!--                      :label="item.label"-->
<!--                      :value="item.value">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="10">-->
<!--                <el-form-item label="日期：">-->
<!--                  <el-date-picker type="monthrange" range-separator="至" v-model="form.dateTime" start-placeholder="开始年月"-->
<!--                                  end-placeholder="结束年月" value-format="yyyy-MM" style="width:100%"></el-date-picker>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="6">-->
<!--                <button type="button" class="count-teaching-button" style="background-color: #2e9bf7" @click="">-->
<!--                  <span style="color: #f8fdfe"><i class="icon-sousuo iconfont"></i> 查询</span>-->
<!--                </button>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-form>-->
<!--        </div>-->

        <el-row :gutter="20">
          <el-col :span="24">
            <el-card style="margin: 10px">
              <div slot="header">
                <span>学生类型数量统计</span>
              </div>
              <div id="genderChart" style="height: 450px;width: 100%;">
              </div>
            </el-card>
          </el-col>
        </el-row>
      </pen-panel>
    </div>

  </div>

</template>

<script>
  import PenPanel  from "../../custom/PenPanel";
  import Pen from "../../custom/Pen";
  import * as echarts from 'echarts';
  import {Message} from "element-ui";
  import cookie from "@/utils/cookie";
  import http from "@/utils/axios";

  export default {
    name: "CountTeaching",
    components: {
      PenPanel,
      Pen,
    },
    props: {
      countTeachingCloseAble: {flag:true},
      editAllFlag: {flag: false}
    },
    data(){
      return{
        options: [{
          value: '博士数量',
          label: '博士数量'
        }, {
          value: '导师数量',
          label: '导师数量'
        }, {
          value: '基础数量',
          label: '基础数量'
        }, {
          value: '博士后合作数量',
          label: '博士后合作数量'
        }],
        form:{
          dateTime:'',
          type:'',
        },
        loadingDataVisible:false,
        childEditAllFlag: false,   //是否显示唯一编辑框标志
      }
    },
    watch:{
      countTeachingCloseAble(newVal){
        if (newVal.flag === false){
          for (let that of Object.keys(this.$refs)) {
            this.$refs[that].closAbleHandler(true)
          }
        }
      },
      editAllFlag(newVal){
        this.childEditAllFlag = newVal.flag;
      }
    },
    methods: {
      getStuTypeData(){
        this.loadingDataVisible = true;
        let token = cookie.getCookie("token");
        http.post(window.config.api.baseUrl + '/eims-api/personal/data/getStuTypeData', {
          token: token,
          data:{
            userId:this.$store.state.MemberManageModule.userId
          }
        }).then((response) => {
            let data = response.data.data;
            // console.log(data)
            this.initStuTypeChart(data.result)
        }).finally(() => {
          this.loadingDataVisible = false;
        })
      },
      initStuTypeChart(data){
        let chartDom = document.getElementById('genderChart');
        let myChart = echarts.init(chartDom);

        let option = {
          legend: {
            top: 'bottom'
          },
          tooltip: {
            trigger: 'item'
          },
          series: [
            {
              name: '统计数量',
              type: 'pie',
              radius: '50%',
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              data: data
            }
          ]
        };

        myChart.setOption(option);
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      },

      //改变所有面板的状态
      closeAll() {
        for (let that of Object.keys(this.$refs)) {
          this.$refs[that].closAbleHandler(true)
        }
      },
    },
    mounted() {
      this.getStuTypeData();
    }
  }
</script>

<style scoped>
  .member-right-inner-bottom {
    clear: both;

  }

  .btn-close-all {
    padding: 5px 5px;
    margin: 5px 20px;
    float: right;
    border-radius: 5px;
    font-size: 16px;
    background-color: #34c5e7;
    color: white;
    border: 0px;
  }

  .count-teaching-button{
    border: 1px solid rgb(105,185,252);
    border-radius: 3px;
    width: 80px;
    height: 40px;
    text-align: center;
    background-image: url('/static/images/fourbackground.png');
  }
  .el-card{
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/memberData/memberTeaching/CountTeaching.vue